import React, { memo } from 'react';
import { animated, easings, useTransition } from 'react-spring';

import Backdrop from '@/components/atomic/atoms/utils/portals/backdrop/styled';
import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import closeNavigationAction from '@/state/selectors/navigation/close-navigation';
import getAnimationDuration from '@/state/selectors/navigation/get-animation-duration';
import getDropdownId from '@/state/selectors/navigation/get-dropdown-id';
import getOpenState from '@/state/selectors/navigation/get-open-state';

const AnimatedBackdrop = animated(Backdrop);

const BackdropHandlerComponent: React.FC = () => {
	const duration = useStore(getAnimationDuration);
	const isOpen = useStore(getOpenState);
	const closeNavigation = useStore(closeNavigationAction);
	const dropdownId = useStore(getDropdownId);

	const transitions = useTransition(isOpen ? dropdownId : null, {
		keys: isOpen ? dropdownId : null,
		from: { opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
		config: { duration, easing: easings.easeInOutCirc },
	});

	return (
		<>
			{transitions((style, item) =>
				item ? (
					<AnimatedBackdrop
						onClick={closeNavigation}
						role='button'
						style={style}
					/>
				) : null,
			)}
		</>
	);
};

const BackdropHandler = memo(
	withExposer(BackdropHandlerComponent, 'backdropHandler'),
);

export default BackdropHandler;
